"use client"
import { ReactNode } from 'react';
import { Typography, Tooltip } from 'antd';
const { Text } = Typography;

export default function CoTypography({
  hoverMsg = '',
  placement = 'top',
  className = '',
  children
}: {
  hoverMsg?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
  children: ReactNode
}) {
  return (
    <Text>
      <Tooltip placement={placement} title={hoverMsg}>
        {children}
      </Tooltip>
    </Text>

  )
}